import React from 'react';
import { connect } from 'react-redux';

import ColoredSectionContainer from 'components/no-auth/common/ColoredSectionContainer';
import { RichText } from 'components/no-auth/common/PromoDangerouslyHtml/RichText';
import HeadingSection from 'components/no-auth/common/sections/HeadingSection';
import { CommonSection, TextComponent } from 'components/no-auth/common/sections/styles';
import NotAuthBasePage from 'components/no-auth/NotAuthBasePage';

const HelpArticleDeeplinkPage = (props) => {
    return (
        <ColoredSectionContainer dimension="average">
            <CommonSection>
                <HeadingSection title={props.helpSectionName} dataTestId="help-article-h1-title" />
                <TextComponent>
                    <RichText tag="div" dangerouslyHtml={props.helpSectionText} dataTestId="help-article-div-text" color="gray80" />
                </TextComponent>
            </CommonSection>
        </ColoredSectionContainer>
    );
};

const mapStateToProps = (state) => {
    return {
        helpSectionName: state.extra?.strapiApi?.Title,
        helpSectionText: state.extra?.strapiApi?.Content,
    };
};

export default connect(mapStateToProps)(NotAuthBasePage(HelpArticleDeeplinkPage));
